import { render, staticRenderFns } from "./Listing.vue?vue&type=template&id=97534c5e&scoped=true"
import script from "./Listing.vue?vue&type=script&lang=js"
export * from "./Listing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97534c5e",
  null
  
)

export default component.exports